<h2 *ngIf="sectionTitle" class="wizard-form-section__title">{{sectionTitle}}</h2>
<ng-content></ng-content>
